import { Layout, PageHeader } from "@/components/Layout";
import { EntityTable } from "@/components/EntityManager";
import { ExportButtons } from "@/components/ExportButtons";
import { StatusPill } from "@/components/StatusPill";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { TRUCK_TYPE, TRAILER_TYPE, ASSET_STATUS, EIA_REGION_OPTIONS } from "@/constants/options";

const rate = (v) => (v == null || v === "" ? <span className="text-neutral-300">—</span> : `$${Number(v).toFixed(2)}/mi`);

export default function Assets() {
  const truckColumns = [
    { key: "asset_type", label: "Type" },
    { key: "unit_number", label: "Unit #" },
    { key: "status", label: "Status", render: (r) => <StatusPill value={r.status} /> },
    { key: "description", label: "Capacity" },
    { key: "rate_per_mile", label: "Rate", align: "right", render: (r) => rate(r.rate_per_mile) },
    { key: "mpg", label: "MPG", align: "right" },
    { key: "eia_region", label: "Diesel Region" },
  ];
  const truckFields = [
    { label: "Truck Type", field: "asset_type", type: "select", options: TRUCK_TYPE },
    { label: "Unit Number", field: "unit_number" },
    { label: "Status", field: "status", type: "select", options: ASSET_STATUS },
    { label: "Description / Capacity", field: "description" },
    { label: "Baseline Rate ($/mile)", field: "rate_per_mile", type: "number" },
    { label: "Fuel Economy (MPG)", field: "mpg", type: "number" },
    { label: "Default Diesel Region", field: "eia_region", type: "select", options: EIA_REGION_OPTIONS },
    { label: "Notes", field: "notes", type: "textarea", span: 2 },
  ];

  const trailerColumns = [
    { key: "asset_type", label: "Type" },
    { key: "unit_number", label: "Trailer #" },
    { key: "status", label: "Status", render: (r) => <StatusPill value={r.status} /> },
    { key: "description", label: "Capacity" },
    { key: "rate_per_mile", label: "Rate", align: "right", render: (r) => rate(r.rate_per_mile) },
  ];
  const trailerFields = [
    { label: "Trailer Type", field: "asset_type", type: "select", options: TRAILER_TYPE },
    { label: "Trailer Number", field: "unit_number" },
    { label: "Status", field: "status", type: "select", options: ASSET_STATUS },
    { label: "Description / Capacity", field: "description" },
    { label: "Baseline Rate ($/mile)", field: "rate_per_mile", type: "number" },
    { label: "Notes", field: "notes", type: "textarea", span: 2 },
  ];

  return (
    <Layout>
      <PageHeader title="Internal Assets" subtitle="Trucks & trailers — assignable individually, each with its own baseline cost">
        <ExportButtons collection="assets" />
      </PageHeader>
      <div className="p-8 animate-fade-up">
        <Tabs defaultValue="trucks" className="w-full">
          <TabsList>
            <TabsTrigger value="trucks" data-testid="tab-trucks">Trucks</TabsTrigger>
            <TabsTrigger value="trailers" data-testid="tab-trailers">Trailers</TabsTrigger>
          </TabsList>
          <TabsContent value="trucks" className="pt-4">
            <EntityTable collection="assets" idKey="trucks" title="Trucks"
              columns={truckColumns} fields={truckFields}
              defaults={{ category: "Truck", status: "Available" }}
              filter={(a) => a.category === "Truck"} />
          </TabsContent>
          <TabsContent value="trailers" className="pt-4">
            <EntityTable collection="assets" idKey="trailers" title="Trailers"
              columns={trailerColumns} fields={trailerFields}
              defaults={{ category: "Trailer", status: "Available" }}
              filter={(a) => a.category === "Trailer"} />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
